import { IOfferType } from "@/modules/serviceOrdering/interfaces/OfferType";

import Axios from "../../../_helpers/axiosHelper";
import { IAgency } from "../interfaces/agency";
import { IGroup } from "../interfaces/group";
import { IManagement, IManagementRole } from "../interfaces/management";
import { IPersonTitle } from "../interfaces/person-title";
// management api
export const getAllGroups = (): Promise<IManagement> =>
  Axios.get(`/groups/get/all`);
export const getAllGroups_old = (): Promise<IManagement> =>
  Axios.get(`/groups`);
import { ITeam } from "../interfaces/team";
import { IUser } from "../interfaces/user";
// management api
export const listTree = (): Promise<IManagement> => Axios.get(`/groups`);

// group api
export const getGroup = (id: string): Promise<IGroup> =>
  Axios.get(`/group/${id}`);
export const createGroup = (group: IGroup) => Axios.post(`/group`, group);
export const updateGroup = (id: string, group: IGroup) =>
  Axios.put(`/group/${id}`, group);
export const deleteGroup = (id: string): Promise<IGroup> =>
  Axios.delete(`/group/${id}`);
export const uploadGroupLogo = (id: string, logo: any) =>
  Axios.post(`/group/${id}/logo`, logo);
export const banGroup = (
  id: string,
  data: {
    isDisabled: boolean;
    reasonDisabled: string | null;
  }
) => Axios.post(`/group/${id}/ban`, data);

// agency api
export const getAgencyById = (id: string): Promise<IAgency> =>
  Axios.get(`/agency/${id}`);
export const createAgency = (agency: IAgency) => Axios.post(`/agency`, agency);
export const updateAgency = (agency: IAgency) =>
  Axios.patch(`/agency/`, agency);
export const deleteAgency = (id: string): Promise<IAgency> =>
  Axios.delete(`/agency/${id}`);
export const uploadAgencyLogo = (id: string, logo: any) =>
  Axios.post(`/agency/${id}/logo`, logo);
export const banAgency = (
  id: string,
  data: {
    isDisabled: boolean;
    reasonDisabled: string | null;
  }
) => Axios.post(`/agency/${id}/ban`, data);

// offer api
export const getAllOfferTypes = (): Promise<{
  offerTypes?: IOfferType[];
}> => Axios.get(`/offerType/all`);

// team api
export const getTeam = (id: string): Promise<ITeam> =>
  Axios.get(`/agency/team/${id}`);
export const getAllTeamServiceTypes = () =>
  Axios.get("/agency/team/service-types");
export const createTeam = (team: ITeam) => Axios.post(`/agency/team`, team);
export const updateTeam = (team: ITeam) => Axios.patch(`/agency/team`, team);
export const deleteTeam = (id: string): Promise<ITeam> =>
  Axios.delete(`/agency/team/${id}`);

// team member api
export const getAssignableMembers = (teamId: string): Promise<IUser[]> =>
  Axios.get(`/agency/team/${teamId}/assignable-members`);
export const addTeamMember = (teamId: string, userId: string): Promise<any> =>
  Axios.post(`/agency/team/${teamId}/member`, { userId });

// person title api
export const getAllPersonTitles = (): Promise<{
  personTitles: IPersonTitle[];
}> => Axios.get(`/personTitle/all`);

// user api
export const getUserById = (id: string): Promise<IUser> =>
  Axios.get(`/user/${id}`);

// get all users
export const getAgencyAdmins = (
  agencyId: string
): Promise<
  {
    label: string;
    value: string;
  }[]
> => Axios.get(`/user/agency-admins/${agencyId}`);
export const createUser = (user: IUser) => Axios.post(`/user`, user);
export const updateUser = (user: IUser) => Axios.patch(`/user`, user);
export const deleteUser = (id: string): Promise<IUser> =>
  Axios.delete(`/user/${id}`);
export const detachUserTeam = (
  userId: string,
  teamId: string
): Promise<IUser> => Axios.put(`/user/${userId}/detach-team/`, { teamId });

// role api
export const getRoles = (): Promise<IManagementRole[]> => Axios.get(`/roles`);
